import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconInfo, IconOutlineClose, IconSuccess, IconWarning } from './icons';
export var Toast = function (_a) {
    var message = _a.message, description = _a.description, status = _a.status, toastId = _a.id, removeToast = _a.removeToast;
    var toastStyles = {
        success: 'vas-bg-vasSuccess vas-text-white',
        error: 'vas-bg-vasDanger vas-text-white',
        info: 'vas-bg-primary vas-text-white',
    };
    var icons = {
        success: _jsx(IconSuccess, { className: 'vas-size-5' }),
        error: _jsx(IconWarning, { className: 'vas-size-5' }),
        info: _jsx(IconInfo, { className: 'vas-size-5' }),
    };
    return (_jsxs("div", { className: "".concat(toastStyles[status], " vas-mb-2 vas-flex vas-w-64 vas-justify-between vas-items-start vas-rounded vas-p-2 vas-text-sm vas-font-semibold"), children: [_jsxs("div", { className: 'vas-flex vas-gap-2 vas-items-center', children: [!!icons[status] && icons[status], _jsxs("div", { className: 'vas-flex-1 vas-font-normal', children: [_jsx("div", { children: message }), description && _jsx("div", { className: 'vas-text-xs vas-font-normal', children: description })] })] }), _jsx("button", { type: 'button', className: 'vas-text-white', onClick: function () { return removeToast(toastId); }, "aria-label": 'Close', children: _jsx(IconOutlineClose, { size: 'md' }) })] }));
};
